$(document).ready(function() {
  const total_invoices = 5;
  var i;
  var yr = new Date().getFullYear();
  for (i = yr; i <= yr + 10; i++) {
    $('#trnExpYear').append($('<option />').val(i.toString().substring(4, 2)).html(i));
  }

  const blank_invoice = $(".invoice_row").length > 0 ? $(".invoice_row")[0].cloneNode(true) : null;


  function hide_buttons(){
    if ($(".invoice_row").length >= total_invoices){
      $("#invoice_add_button").hide()
    } else if ($(".invoice_row").length <= 1) {
      $("#invoice_delete_button").hide()
    } else {
      $("#invoice_delete_button").show()
      $("#invoice_add_button").show()
    }
  }

  hide_buttons();

  $("#invoice_add_button").click(function(){
    const index_number = $(".invoice_row").length + 1;

    var row = blank_invoice.cloneNode(true);
    var invoice_number = $(row).find("#ref3_1");
    var invoice_amount = $(row).find("#ref4_1");

    $(row).find("label")[0].setAttribute("for", `ref3_${index_number}`);
    $(row).find("label")[1].setAttribute("for", `ref4_${index_number}`);

    invoice_number.attr("id", `ref3_${index_number}`);
    invoice_number.attr("name", `ref3_${index_number}`);
    invoice_number.mask('AAAAAAAAAA');

    invoice_amount.attr("id", `ref4_${index_number}`);
    invoice_amount.attr("name", `ref4_${index_number}`);
    invoice_amount.maskMoney({prefix: '$', thousands: "", decimal: '.'});

    invoice_amount.keyup(recalculate_total);
    invoice_amount.on('change blur', validate);

    $(row).find("#ref4_1-error").attr("id", `ref4_${index_number}-error`)

    $("#invoice_rows")[0].appendChild(row);
    hide_buttons();
  })

  $("#invoice_delete_button").click(function(){
    var rows = $(".invoice_row")
    rows[rows.length - 1].remove();
    recalculate_total();
    hide_buttons();
  })

  $('#ref1').keyup(function() {
    $('#indexed_ref').val($('#ref1').val());
  });

  $('.invoice_amt').keyup(recalculate_total);

  $('#option3').on('click', function(){    
    if($(this).is(':checked')) {
      $('#ref5').prop('checked', true).attr('readonly', true);
    } else {
      $('#ref5').attr('readonly', false);
    }
  });

  $('#ref5').on('click', function(){
    if($('#option3').is(':checked')){
      $(this).prop('checked', true);
    }
  });

  function recalculate_total() {
    var total = 0;
    $('.invoice_amt').each(function() {
      var amt = $(this).val();
      if (!isNaN(parseFloat(amt.substring(1)))) {
        total += parseFloat(amt.substring(1));
        $('#'+$(this).attr("id")+'-error').hide();
      }
    });
    $('#trnAmount').val('$' + total.toFixed(2));
  }

  var invoiceErrorText = 'Enter an invoice amount greater than zero';
  if(getCookie('wp-wpml_current_language') == 'fr') {
    invoiceErrorText = 'Entrez un montant supérieur à zéro';
  }

  $('.invoice_amt').on('change blur', validate);

  function validate(){
    var invoiceAmt = ($(this).val().substring(1));
    var id = $(this).attr("id");

    if (isNaN(invoiceAmt) || (invoiceAmt <= 0)) {
      $(`#${id}-error`).show().html(invoiceErrorText);
    } else {
      $(`#${id}-error`).hide().html('');
    }
  }

  $('#paymentForm').submit(function() {
    var refList = '';
    var refAmt = '';
    const rows = $(".invoice_row").length;
    for (let index = 1; index <= rows; index++) { 
      refList += ', ' + $('#ref3_' + index).val();
      refAmt += ', ' + $('#ref4_' + index).val().replace(/\$/g, '');
    }

    $('.invoice_amt').each(validate);

    $('#ref3').val(refList.substring(1).replace(/\$/g, ''));
    $('#ref4').val(refAmt.substring(1).replace(/\$/g, ''));

    $('#trnAmount').val($('#trnAmount').val().replace(/\$/g, '')); //remove dollar sign
  });

  $.jMaskGlobals = {
    maskElements: 'input,td,span,div',
    dataMaskAttr: '*[data-mask]',
    dataMask: true,
    watchInterval: 300,
    watchInputs: true,
    watchDataMask: false,
    byPassKeys: [
      9,
      16,
      17,
      18,
      36,
      37,
      38,
      39,
      40,
      91,
    ],
    translation: {
      'T': {
        pattern: /[A-Za-z,\-, ]/,
        recursive: true,
      },
      '0': {
        pattern: /\d/,
      },
      '9': {
        pattern: /\d/,
        optional: true,
      },
      '#': {
        pattern: /\d/,
        recursive: true,
      },
      'A': {
        pattern: /[a-zA-Z0-9]/,
      },
      'S': {
        pattern: /[a-zA-Z]/,
      },
    },
  };

  $('#ordPhoneNumber').mask('000-000-0000');
  $('.name').mask('T');
  $('#city').mask('T');
  $('#ref1').mask('AAAAAAAAAA');
  /* $('.invoice_amt').mask('$.00'); */
  $('.invoice_no').mask('AAAAAAAAAA');
  $('#ordPostalCode').mask('A0A 0A0');
  $('.numaric').mask('0#');
  $('.tridigit').mask('000');

});

$(".invoice_amt").maskMoney({prefix: '$', thousands: "", decimal: '.'});
$("#trnAmount").maskMoney({prefix: '$', thousands: "", decimal: '.'});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
